export const types = {
  en: '[Lang] English',
  es: '[Lang] Espanish',

  posts: '[Posts] Load',
}